import { CapacityUtilization } from '../capacity-utilization.types';

export const EMPTY_CAPACITY_UTILIZATION: CapacityUtilization = {
	id: 0,
	plannedDeliveryWindowId: 0,
	fillRatio: 0,
	additionalAttributes: {
		usedTaskCapacity: 0
	},
	fillRatioData: {
		fillRatioBy: '',
		orders: {
			assignedCount: 0,
			maxCount: 0
		},
		reservedCapacity: {
			ratio: 0
		},
		routeDuration: {
			totalSlotSeconds: 0,
			deliveryBlockSeconds: 0,
			reservedSeconds: 0,
			availableSeconds: 0,
			plannedSeconds: 0,
			totalLoadingTimeMinutes: 0,
			totalUnloadingTimeMinutes: 0,
			totalBreakSeconds: 0
		},
		resources: {
			plannedCount: 0,
			totalCount: 0
		},
		weight: {
			plannedKg: 0,
			reservedKg: 0,
			maxKg: 0
		},
		handlingUnits: {
			unitType: '',
			planned: 0,
			reserved: 0,
			max: 0
		}
	}
};
